export default __webpack_public_path__ + "static/media/event-form.766a3a42.png";